var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaryPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "galary_ic",
    transform: "translate(-500 -222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3752",
    "data-name": "Rectangle 3752",
    transform: "translate(500 222)",
    fill: "#fff",
    stroke: "#1c97cf",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 121,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 120,
    height: 120,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(533 255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M48.889,0H6.111A6.109,6.109,0,0,0,0,6.111V48.889A6.109,6.109,0,0,0,6.111,55H48.889A6.109,6.109,0,0,0,55,48.889V6.111A6.109,6.109,0,0,0,48.889,0ZM6.111,45.833l10.694-13.75,7.639,9.182L35.139,27.5l13.75,18.333Z",
    fill: "#1c97cf"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaryPlaceholder);
export default __webpack_public_path__ + "static/media/galaryPlaceholder.e085d6a5.svg";
export { ForwardRef as ReactComponent };